export default __webpack_public_path__ + "static/media/MINISTERIODEECONOMIA.d1618f66.svg";